import { IPagedQuery, IPagedQueryS } from '../components/paginate';
import * as actionTypeProfile from '../action/profile';
import { UploadRelationType } from '../enums/UploadRelationType';

export interface IPageProps {
    history?: any;
    location?: any;
    match?: any;
    dispatch?: any;
}

export interface IOtherFileView {
    id: string;
    fileName: string;
    extension: string;
    s3FileKey: string;
    s3FileSize: number;
    s3FileLastModified: string;
    s3FolderBasedObjectType: number;
    totalCount: number;
}

export interface IOtherFileListPageProps extends IPageProps {
    results?: IOtherFileView[];
    filters?: IPagedQuery;
    coursePageClassId?: string;
    userPreferences?: actionTypeProfile.IPreference[];
    userType?: any;
}

export interface IOtherFileListPageState {
    filters: IPagedQueryS;
    model: IOtherFileView;
    all_ids: Array<any>;
    selected_ids: Array<any>;
    goToStorageManagementPage: boolean;
    filterInitialValues: any;
    unselected_ids?: Array<any>;
    loading: boolean
}

export const OtherFileInitialValues: IOtherFileView = {
    id: '',
    fileName: '',
    extension: '',
    s3FileKey: '',
    s3FileSize: 0,
    s3FileLastModified: '',
    s3FolderBasedObjectType: 0,
    totalCount: 0
};

export const FilterInitialValues: IPagedQueryS = {
    orderBy: '',
    page: 1,
    take: 10,
    query: '',
    skip: 0,
    total: -1
};

export enum ObjectTypes {
    ActivityUnzippedFilesRar = 4,
    Report = 6,
    ScreenShot = 11,
    Question = 12,
    QuestionChoice = 13,
    Shared = 14,
    ElessonUnzipped = 15
}